var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.name)?_c('svg',{staticClass:"icon",attrs:{"height":_vm.height,"width":_vm.width,"fill":_vm.fill,"stroke":_vm.stroke}},[_c('use',{attrs:{"xlink:href":_vm.sprite + '#' + _vm.name,"href":_vm.sprite + '#' + _vm.name}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }